<template>
  <div>
    <div class="breadcrumb">
      <h1 style="color: #AC8400;">Charity</h1>
    </div>

    <!-- Breadcrumbs -->
    <div style="padding: 10px; background-color: #F2F2F2">
      <router-link to="/dashboard">Dashboard</router-link>
      /
      <b>{{ lps() }}</b>
      /
      <router-link to="/lps/charity">Charity</router-link>
      /
      <b>Details</b>
    </div>
    <!-- End of breadcrumbs -->

    <div class="separator-breadcrumb border-top"></div>
    <div class="mb-3">
      <!-- <span class="mr-2"><b>Officer:</b> Ali Ahmad</span> -->
      <!-- <span><b>Date Taken:</b> 29th February 2020</span> -->
    </div>
    <div class="row mb-4">
      <div class="col-md-12 mb-4">
        <!-- Active -->
        <div class="card text-left">
          <div class="card-body">
            <h4 class="card-title mb-3">Charity Details</h4>
            <br />

            <div class="row">
              <div class="col-12 mb-3">
                <label class="fontBold">Name: </label>
                <input type="text" class="form-control mb-1" v-model="details.name" />
                <label class="fontBold">Description: </label>
                <input type="text" class="form-control mb-1" v-model="details.description" />
              </div>
              <div class="col-3">
                <label class="fontBold">Image: </label>
                <br />
                <label style="color: red">(Recommended size for image 250 X 250px)</label>
                <input type="file" ref="image" class="form-control" />
                <br />
                <img src="" width="50%" class="mb-2" />
              </div>

              <div class="col-5">
                <label class="fontBold">Banner Image: </label>
                <br />
                <label style="color: red">(Recommended size for image 468 X 60px)</label>
                <input type="file" ref="banner" class="form-control" v-on:change="handleFileUpload()" />
                <br />
                <img :src="src" width="50%" class="mb-2" />
                <br />
              </div>

              <div class="col-4">
                <label class="fontBold">Duration: </label>
                <br />
                <datepicker v-model="details.start_at" width="300px"></datepicker>

                <div class="col-3" style="text-align: center">
                  <label class="mt-2"> to </label>
                </div>
                <datepicker v-model="details.end_at" width="300px"></datepicker>

                <label>Activation Status</label>
                <div class="row">
                  <label class="radio radio-success mr-3">
                    <input type="radio" name="radio" v-model="details.active" v-bind:value="a" />
                    <span>Active</span>
                    <span class="checkmark"></span>
                  </label>
                  <label class="radio radio-danger">
                    <input type="radio" name="radio" v-model="details.active" v-bind:value="b" />
                    <span>Inactive</span>
                    <span class="checkmark"></span>
                  </label>
                </div>
              </div>
            </div>

            <div class="row mt-2">
              <div class="col-12 text-center">
                <button class="btn btn-lg btn-primary col-2" @click="onApprove()">
                  Approve
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import axios from "axios";
import dateManipulation from "@/mixins/dateManipulation";
import vSelect from "vue-select";
import moment from "moment";
import "vue-select/dist/vue-select.css";
import datepicker from "vuejs-datetimepicker";

export default {
  name: "charity-details",
  mixins: [dateManipulation],
  props: ["edit"],
  components: { vSelect, datepicker },

  data() {
    return {
      details: {},
      a: 1,
      b: 0,
      src: ""
    };
  },

  methods: {
    async loadDetails() {
      let token = localStorage.getItem("token");
      let id = this.$route.params.id;

      // check if has token
      if (token !== null) {
        token = JSON.parse(token);
        token = token.access_token;
        let count = 0;
        try {
          let result = await axios.get(axios.lpsURL + "/charity/getOne/" + id, {
            headers: {
              Authorization: "Bearer " + token
            }
          });
          this.details = result.data;

          if (this.details.banner != null) {
            this.loadPendingImage(token, id);
          }
        } catch (error) {
          console.log(error);
        }
      }
    },

    loadPendingImage(token, id) {
      axios
        .get(axios.lpsURL + "/charity/banner/" + id + "/show", {
          headers: {
            Authorization: "Bearer " + token
          },
          responseType: "blob"
        })
        .then(response => {
          let reader = new FileReader();
          reader.readAsDataURL(response.data);
          reader.onload = () => {
            this.src = reader.result;
          };
        });
    },

    // Check Token
    checkToken() {
      let token = localStorage.getItem("token");
      if (token != null) {
        token = JSON.parse(token);
        token = token.access_token;
        return token;
      }
      return alert("Not Authorised");
    },

    onApprove() {
      let id = this.$route.params.id;
      let token = localStorage.getItem("token");
      if (token == null) {
        Swal({
          icon: "error",
          text: "Not Authorised"
        });
        return;
      }

      token = JSON.parse(token);
      token = token.access_token;

      let formdata = new FormData();
      formdata.append("name", this.details.name);
      formdata.append("description", this.details.description);
      formdata.append("image", this.details.image);
      formdata.append("banner", this.details.banner);
      formdata.append("start_at", this.details.start_at);
      formdata.append("end_at", this.details.end_at);
      formdata.append("active", this.details.active);

      swal({
        icon: "warning",
        text: "Are you sure?",
        buttons: ["Cancel", "Yes"]
      }).then(confirm => {
        if (!confirm) {
          return;
        }
        axios
          .post(axios.lpsURL + "/charity/update/" + id, formdata, {
            headers: {
              Authorization: "Bearer " + token,
              "Content-Type": "multipart/form-data"
            }
          })
          .then(res => {
            if (res.data.success) {
              swal({
                icon: "success",
                text: res.data.message
              });
            } else {
              swal({ icon: "error", text: res.data.message });
            }
          });
      });
    },

    dateFormatChange(dateString) {
      if (dateString.includes("/")) {
        return dateString;
      }
      let date = dateString.split("-");
      return date[2] + "/" + date[1] + "/" + date[0];
    },

    handleFileUpload() {
      this.details.image = this.$refs.image.files[0];
      this.details.banner = this.$refs.banner.files[0];
    },

    lps() {
      return this.$lps();
    }
  },

  async created() {
    await this.loadDetails();
    console.log(this.src);
  },

  mounted() { }
};
</script>

<style>
.fontBold {
  font-weight: bold;
}
</style>
